import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {FormlyModule} from '@ngx-formly/core';
import {NgPrimeModule} from '../app.ngprime.module';
import {CommonModule} from '@angular/common';
import {FormlyFieldCalendar} from '@shared/components/formly-field-primeng-calendar';
import {FormlyFieldListBox} from '@shared/components/formly-field-primeng-listbox';
import {FormlyFieldFile} from '@shared/components/formly-field-file.component';
import {FormlyFieldTabs} from '@shared/components/formly-field-primeng-tabs';
import {FormlyWrapperFormField} from '@shared/components/form-field.wrapper';
import {PropPipe} from './pipes/field-pipe.pipe';
import {FormlyWrapperNon} from '@shared/components/form-field-nowrapper';
import {RepeatTypeComponent} from '@shared/components/repeat-section.type';
import {FormlyFieldChips} from '@shared/components/formly-field-primeng-chipst';
import {TableModule} from 'ngx-easy-table';
import {CourseSelectComponent} from './components/course-select.component';
import {MenuDialogComponent} from '@shared/components/menu-dialog.component';
import {ConfirmDeleteDirective} from '@shared/directives/confirm-delete.directive';
import {ConfirmSaveDirective} from '@shared/directives/confirm-save.directive';
import {FormlyFooterComponent} from './components/formly-footer.component';
import {EasyTableComponent} from '@shared/components/easy-table.component';
import {NgxJsonViewerModule} from 'ngx-json-viewer';
import {JsonViewerComponent} from './components/json-viewer.component';
import {ToolBarComponent} from './components/tool-bar.component';
import {TagListComponent} from './components/tag-list.component';
import {ModelViewerComponent} from './components/model-viewer.component';
import {InputDialogComponent} from './components/input-dialog.component';
import {FormlyFieldMultiSelect} from '@shared/components/formly-field-primeng-multiselect';
import {FormlyFieldCourseSelect} from '@shared/components/formly-field-course-select';
import {PriceRuleTableComponent} from '@shared/components/price-rule-table.component';
import {TicketSelectComponent} from './components/ticket-select.component';
import {TextNumberPipe} from './pipes/text-number.pipe';
import {TwoDigitDecimalNumberDirective} from './directives/two-digit-decimal-number.directive';
import {FormlyFieldFileInputType} from '@shared/components/formly-field-file-input-type.component';
import {FormlyFieldFileInputValueAccessor} from '@shared/components/formly-field-file-input-value-accessor';
import {ReserveTableComponent} from './components/reserve-table.component';
import {UserCardComponent} from './components/card/user-card.component';
import {SlotCardComponent} from './components/card/slot-card.component';
import {StatCardComponent} from './components/card/stat-card.component';
import {PriceRuleTablesComponent} from '@shared/components/price-rule-tables.component';
import {UserSelectComponent} from '@shared/components/user-select.component';
import {SlotGridComponent} from '@shared/components/slot-grid.component';
import {SlotCellComponent} from '@shared/components/slot-cell.component';
import {NgPipesModule} from 'ngx-pipes';
import {FormlyCenterWrapper} from '@shared/components/form-field-center.wrapper';
import {TagReserveStatusComponent} from '@shared/components/tag-reserve-status.component';
import {NoteViewComponent} from './components/note-view.component';
import {DayAgoPipe} from './pipes/day-ago.pipe';
import {RedirectorComponent} from './components/redirector/redirector.component';
import {ConfirmDirective} from './directives/confirm.directive';
import {TagComponent} from './components/tag/tag.component';
import {DaysDiffPipe} from './pipes/days-diff.pipe';
import {IsSameDatePipe} from './pipes/is-same-date.pipe';
import {PercentageBarComponent} from '@shared/components/percentage-bar/percentage-bar.component';
import {FormlyWrapperFormFieldOffset3} from '@shared/components/form-field-offset-3.wrapper';
import {GolferNamePipe} from '@shared/pipes/golfer-name.pipe';
import {CourseSettingViewComponent} from './components/course-setting-view/course-setting-view.component';
import {FormlyFieldHtml} from '@shared/components/formly-field-html';
import {CKEditorModule} from '@ckeditor/ckeditor5-angular';
import {CourseNamePipe} from './pipes/course-name.pipe';
import {TextWithLineBreaksPipe} from './pipes/text-with-line-breaks-pipe.pipe';
import {TagPaymentStatusComponent} from './components/tag-payment-status/tag-payment-status.component';
import {TagRefundStatusComponent} from './components/tag-refund-status/tag-refund-status.component';
import {DiscountTagComponent} from './components/discount-tag/discount-tag.component';
import {CopyToClipBoardComponent} from './components/copy-to-clip-board/copy-to-clip-board.component';
import {ShopSelectComponent} from './components/shop-select.component';
import {CsvImporterComponent} from '@shared/components/csv-importer/csv-importer.component';
import {CoursePriceRuleTableComponent} from '@shared/components/course-price-rule-table/course-price-rule-table.component';
import {CoursePriceRulesComponent} from '@shared/components/course-price-rules/course-price-rules.component';
import {DayRangeDisplayComponent} from './components/day-range-display/day-range-display.component';
import {DateRangeStatusComponent} from './components/date-range-status/date-range-status.component';
import {EventLogViewerComponent} from './components/event-log-viewer/event-log-viewer.component';
import {CartSettingCardComponent} from './components/card/cart-setting-card/cart-setting-card.component';
import {PriceDisplayComponent} from '@shared/components/price-display/price-display.component';
import {TransferCardComponent} from '@shared/components/card/transfer-card/transfer-card.component';
import {CaddySettingCardComponent} from '@shared/components/card/caddy-setting-card/caddy-setting-card.component';
import {ShopLeisureSelectComponent} from '@shared/components/shop-leisure-select/shop-leisure-select.component';
import {CustomSelectComponent} from './components/formly/custom-select/custom-select.component';
import {PackageInfoTableComponent} from './components/package-info-table.component';
import {PackageInfoTablesComponent} from '@shared/components/package-info-tables.component';
import {CouponStatusComponent} from '@shared/components/coupon-status/coupon-status.component';
import {CouponTypeComponent} from '@shared/components/coupon-type/coupon-type.component';
import {TimeAgoPipe} from '@shared/pipes/time-ago.pipe';
import {DayRangePipe} from '@shared/pipes/day-range.pipe';
import {NgToggleModule} from 'ng-toggle-button';
import {PackageSelectComponent} from '@shared/components/package-select.component';
import {CostsViewComponent} from '@shared/components/costs-view/costs-view.component';
import {CostRefundDialogComponent} from '@shared/components/cost-refund-dialog/cost-refund-dialog.component';
import { SettlementStatusComponent } from './components/settlement-status/settlement-status.component';

const modules = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  NgPrimeModule,
  FormlyModule,
  TableModule,
  NgxJsonViewerModule,
  NgPipesModule,
  CKEditorModule,
  NgToggleModule
];

const components = [
  CourseSelectComponent,
  ShopSelectComponent,
  PackageSelectComponent,
  TicketSelectComponent,
  MenuDialogComponent,
  EasyTableComponent,
  JsonViewerComponent,
  ToolBarComponent,
  TagListComponent,
  TagReserveStatusComponent,
  TagPaymentStatusComponent,
  TagRefundStatusComponent,
  UserCardComponent,
  UserSelectComponent,
  SlotGridComponent,
  SlotCellComponent,
  NoteViewComponent,
  RedirectorComponent,
  DiscountTagComponent,
  CsvImporterComponent,
  CoursePriceRuleTableComponent,
  CoursePriceRulesComponent,
  DayRangeDisplayComponent,
  PriceDisplayComponent,
  DateRangeStatusComponent,
  EventLogViewerComponent,
  CsvImporterComponent,
  CartSettingCardComponent,
  TransferCardComponent,
  CaddySettingCardComponent,
  ShopLeisureSelectComponent,
  CostsViewComponent,
  CostRefundDialogComponent,
  SettlementStatusComponent
];

const formlyCustoms = [
  FormlyFieldCalendar,
  FormlyFieldMultiSelect,
  FormlyFieldListBox,
  FormlyFieldFile,
  FormlyFieldFileInputType,
  FormlyFieldFileInputValueAccessor,
  FormlyFieldTabs,
  FormlyFieldChips,
  FormlyWrapperFormField,
  FormlyWrapperNon,
  FormlyCenterWrapper,
  FormlyWrapperFormFieldOffset3,
  RepeatTypeComponent,
  FormlyFooterComponent,
  FormlyFieldCourseSelect,
  CustomSelectComponent,
  FormlyFieldHtml,
  ModelViewerComponent,
  InputDialogComponent,
  PriceRuleTableComponent,
  PriceRuleTablesComponent,
  PackageInfoTableComponent,
  PackageInfoTablesComponent,
  TwoDigitDecimalNumberDirective,
  ReserveTableComponent,
  UserCardComponent,
  SlotCardComponent,
  StatCardComponent,
  TagComponent,
  PercentageBarComponent,
  StatCardComponent,
  CourseSettingViewComponent,
  CopyToClipBoardComponent,
  CouponStatusComponent,
  CouponTypeComponent,
];

const pipes = [
  PropPipe,
  TextNumberPipe,
  DayAgoPipe,
  DaysDiffPipe,
  IsSameDatePipe,
  GolferNamePipe,
  CourseNamePipe,
  TextWithLineBreaksPipe,
  TimeAgoPipe,
  DayRangePipe
];

const directives = [
  ConfirmDeleteDirective,
  ConfirmSaveDirective,
  ConfirmDirective
];

@NgModule({
  imports: [...modules],
  declarations: [...formlyCustoms, ...pipes, ...components, ...directives],
  exports: [...modules, ...formlyCustoms, ...pipes, ...components, ...directives]
})
export class SharedModule {
}
